import React, { useContext } from 'react';

import styled from '@emotion/styled';

import useRejectionReason from '../../../../hooks/dashboard/BaDriverVerification/useRejectionReason';
import {
  IndicateIssuesDataType,
  IndicateIssuesInitialValues,
  IndicateIssuesSchema,
} from '../../../../models/dashboard/ba-verification/indicate-issues';
import { FormSubmitButton } from '../../../Button/FormSubmitButton';
import {
  CustomRectangularStackedRadio,
  CustomStackedRectangularRadioFieldGroup,
} from '../../../FormCom/CustomStackedRectangularRadioField';
import { FormComponent } from '../../../FormCom/FormComponent';
import { TableContext } from '../../../Table/TableContext';
import ModalContainer from '../../ModalContainer';
import { ModalContext } from '../../ModalContext';

interface RejectionIssuesModalProps {
  data?: any;
}

const RejectionIssuesModal: React.FC<RejectionIssuesModalProps> = ({
  data,
}) => {
  const modalContext = useContext(ModalContext);
  const { setRejectionReasons, loading } = useRejectionReason();
  const tableContext = useContext(TableContext);

  const onSubmit = (value: IndicateIssuesDataType) => {
    setRejectionReasons(value, data?.id ?? '', () => {
      modalContext?.setShowModal(false);
      tableContext?.setRefreshTable(!tableContext?.refreshTable);
    });
  };

  return (
    <ModalContainer label='Rejection Profile'>
      <FormComponent
        initialValues={IndicateIssuesInitialValues}
        schema={IndicateIssuesSchema}
        onSubmit={onSubmit}
        className={'large-gap'}
      >
        <CustomStackedRectangularRadioFieldGroup
          name='issue'
          label='Select reason for rejection'
        >
          <CustomRectangularStackedRadio
            name='issue'
            value='Duplicate driver image'
          >
            Duplicate driver image
          </CustomRectangularStackedRadio>
          <CustomRectangularStackedRadio
            name='issue'
            value='Blurry driver image'
          >
            Blurry driver image
          </CustomRectangularStackedRadio>
          <CustomRectangularStackedRadio name='issue' value='Invalid NIN'>
            Invalid NIN
          </CustomRectangularStackedRadio>
          <CustomRectangularStackedRadio
            name='issue'
            value='Issue confirming DOB'
          >
            Issue confirming D.O.B
          </CustomRectangularStackedRadio>
          <CustomRectangularStackedRadio
            name='issue'
            value='Inaccurate driver name'
          >
            Inaccurate driver name
          </CustomRectangularStackedRadio>
        </CustomStackedRectangularRadioFieldGroup>

        <ButtonArea>
          <FormSubmitButton
            className='clear fill'
            onClick={() => modalContext?.setShowModal(false)}
            btnType='button'
          >
            Cancel
          </FormSubmitButton>
          <FormSubmitButton loading={loading} className='fill'>
            Save
          </FormSubmitButton>
        </ButtonArea>
      </FormComponent>
    </ModalContainer>
  );
};

export default RejectionIssuesModal;

const ButtonArea = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;
